import { get } from 'lodash'
import styled from 'styled-components'

import { type IProgressProps } from '..'

export interface IProgressStyledProps extends IProgressProps {}

export const ProgressStyled = styled.div<IProgressStyledProps>`
  width: 100%;

  ${(props) => {
    const barColor = get(props.theme.colors, props.color)

    return (
      barColor &&
      `.MuiLinearProgress-barColorPrimary {
    background-color: ${barColor};
  }
  .MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer) {
    background-color: ${barColor};
  }
  .MuiLinearProgress-dashedColorPrimary {
    background-image: radial-gradient(${
      barColor
    } 0%, ${barColor} 16%, transparent 42%);
  }
  `
    )
  }}

  ${(props) =>
    props.striped &&
    `.bar {
      background-image: repeating-linear-gradient( 45deg, transparent, transparent 5px, ${
        props.theme.colors.white
      } 5px, ${props.theme.colors.white} 10px );
      border: 1px solid ${
        get(props.theme.colors, props.color) ??
        props.theme.colors.content.border
      };
    }`}
`
